import React, { ReactElement } from 'react'

import Icon from '../Icon'

type TPrefixIconProps = { icon: string }

const PrefixIcon = (props: TPrefixIconProps): ReactElement => {
  const { icon } = props

  return (
    <>
      <div style={{ position: 'absolute', top: '28%', left: '10px' }}>
        <Icon icon={icon} />
      </div>
    </>
  )
}

export default PrefixIcon
